import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@material-ui/core';

const PanelPrograms = ({ title, programs }) => {
  return (
    <React.Fragment>
      <Typography variant='h6' gutterBottom>
        {title}
      </Typography>
      <List dense={true}>
        {programs.length > 0 ? (
          programs.map((program) => (
            <ListItem key={program.id}>
              <ListItemText
                primary={program.name}
                secondary={`LÍNEA: ${program.line.name}`}
              />
            </ListItem>
          ))
        ) : (
          <ListItem>
            <ListItemText primary={'No existen registros'} />
          </ListItem>
        )}
      </List>
    </React.Fragment>
  );
};

export default PanelPrograms;
